import routeReplaceSelf from '@/utils/routeReplaceSelf';
const custSetting = {
    path: 'custSetting',
    name: 'custSetting',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'setting',
        icon: 'HSIconfont hs-icon-code',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custEmailConfig',
            name: 'custEmailConfig',
            // component: () => import('@/views/custEmailConfig'),
            component: routeReplaceSelf(() => import('@/views/custEmailConfig')),
            meta: { code: 'setting:emailConfig' },
            children: [
                {
                    path: 'custEmailConfigAdd',
                    name: 'custEmailConfigAdd',
                    hidden: true,
                    component: () => import('@/views/custEmailConfig/components/Add'),
                    meta: {
                        code: 'setting_emailConfig_create',
                        activeMenu: 'custEmailConfig',
                    },
                },
                {
                    path: 'custEmailConfigUpdate',
                    name: 'custEmailConfigUpdate',
                    hidden: true,
                    component: () => import('@/views/custEmailConfig/components/Edit'),
                    meta: {
                        code: 'setting_emailConfig_update',
                        activeMenu: 'custEmailConfig',
                    },
                }
            ]
        },
        {
            path: 'custTimingUpdate',
            name: 'custTimingUpdate',
            component: () => import('@/views/custTimingUpdate'),
            meta: { code: 'setting:timingUpdateEslStrategy' }
        },
        {
            path: 'custConfig',
            name: 'custConfig',
            component: () => import('@/views/custConfig'),
            meta: { code: 'setting:customerConfig' }
        },
        {
            path: 'custEslAttrConfig',
            name: 'custEslAttrConfig',
            component: () => import('@/views/custEslAttrConfig'),
            meta: { code: 'setting:eslConfig' }
        },
        {
            path: 'custDisabledGoods',
            name: 'custDisabledGoods',
            component: () => import('@/views/custDisabledGoods'),
            meta: { code: 'setting:goodsBlackList' }
        },
        {
            path: 'custExportConfig',
            name: 'custExportConfig',
            component: () => import('@/views/custExportConfig'),
            meta: { code: 'setting:bindExportField' }
        },
        {
            path: 'custMoveConfig',
            name: 'custMoveConfig',
            component: () => import('@/views/custMoveConfig'),
            meta: { code: 'setting:moveConfig' }
        },
        {
            path: 'custTempCorrespondence',
            name: 'custTempCorrespondence',
            component: () => import('@/views/custTempCorrespondence'),
            meta: { code: 'setting:TemplateList' }
        },
        {
            path: 'custSystemConfig',
            name: 'custSystemConfig',
            component: () => import('@/views/custSystemConfig'),
            meta: { code: 'setting:systemConfig' }
        },
        {
            path: 'custProfileConfig',
            name: 'custProfileConfig',
            component: () => import('@/views/custProfileConfig'),
            meta: { code: 'setting:profile' }

        },
    ]
};

export default custSetting;
